import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/MathClub/components/Archive2022';
import Sidebar2026 from '../MathClub2023/components/Sidebar2026/Sidebar2026';


const MathCCAClass3to52026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/8.webp`;
    const p9 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/9.webp`;
    const p10 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/10.webp`;
    const p11 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/11.webp`;
    const p12 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/12.webp`;
    const p13 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/13.webp`;
    const p14 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/14.webp`;
    const p15 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/15.webp`;
    const p16 = `${config.base_image_url_2026}/home/events-activities/association/MathClub/MathCCA3to5/16.webp`;




    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
         {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
         {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
         {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 1,
            cols: 1,
        },
        {
            src: p10,
            source: p10,
            rows: 1,
            cols: 1,
        },
        {
            src: p11,
            source: p11,
            rows: 1,
            cols: 1,
        },
        {
            src: p12,
            source: p12,
            rows: 1,
            cols: 1,
        },
        {
            src: p13,
            source: p13,
            rows: 1,
            cols: 1,
        },
         {
            src: p14,
            source: p14,
            rows: 1,
            cols: 1,
        },
         {
            src: p15,
            source: p15,
            rows: 1,
            cols: 1,
        },
         {
            src: p16,
            source: p16,
            rows: 1,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                {/* <Typography variant='h4' align='center'>
                                   Bridge builder	                                  
                                </Typography> */}
                                <br></br>
                               
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                   CLASSES: 3-5  Date: 31 August, 03 and 04 September 2026
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The final round of the Math CCA for Classes 3, 4 and 5 was conducted on 31 August, 3 September and 4
September 2026. Students creatively applied mathematical concepts through hands-on activities, transforming
their Egg Magic Tangram pieces into meaningful and artistic creations.
                                    <br></br>
Class 3 explored the theme “Where Geometry Meets Nature.” Students used their Tangram pieces to create
nature-inspired wall hangings. Through shapes, patterns and spatial arrangements, they demonstrated how
geometry can be found in the world around us.
                                    <br></br>
Class 4 explored the theme “Where Geometry Meets Heritage.” Students transformed their Tangram pieces
into tribal-inspired coasters, exploring tessellation, patterns and geometric arrangements while connecting
Mathematics with traditional art and heritage.
                                   <br></br>
                                   Class 5 worked on the theme “Where Geometry Meets Light.” Students created Magic Shadow Boxes,
experimenting with geometric arrangements and light to transform the same pieces into patterns and
recognisable figures.
                                    <br></br>
                                    The culmination was an enriching experience that encouraged students to create, explore, reason and present,
making Mathematics a vibrant blend of geometry, creativity and imagination.
 <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                      variant={'h6'}
                                      color={'primary'}
                                      align={'center'}
                                      fontWeight={'normal'}
                                    ><br/>
“When shapes meet imagination, Mathematics comes alive.”                            
                            <br/>
                                    </Typography>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default MathCCAClass3to52026;